import { useState, useEffect } from "react";
import CardNews from "../ui_elements/news/CardNews";
import Categories from "../ui_elements/news/Categories";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

const News = () => {
  const [news, setNews] = useState([]); // Lista completa de notícias
  const [filteredNews, setFilteredNews] = useState([]); // Lista filtrada de notícias
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleNewsCount, setVisibleNewsCount] = useState(5); // Número de notícias visíveis

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await fetch("/assets/json/news.json");

        if (!response.ok) {
          throw new Error(`Erro na requisição: ${response.statusText}`);
        }

        const data = await response.json();

        // Verifica se o JSON contém a propriedade "news" como array
        if (data.news && Array.isArray(data.news)) {
          setNews(data.news);
          setFilteredNews(data.news);

          // Extrai categorias únicas
          const uniqueCategories = [
            ...new Set(data.news.map((item) => item.category.name)),
          ];
          setCategories(uniqueCategories);
        } else {
          throw new Error(
            "O JSON não contém um array válido na propriedade 'news'.",
          );
        }
      } catch (error) {
        console.error("Erro ao carregar o JSON:", error);
      }
    };

    fetchNews();
  }, []);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    const filtered = category
      ? news.filter((item) => item.category.name === category)
      : news;
    setFilteredNews(filtered);
    setVisibleNewsCount(5); // Reinicia a contagem de notícias visíveis
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    const filtered = query
      ? news.filter(
          (item) =>
            item.title.toLowerCase().includes(query.toLowerCase()) ||
            item.content.toLowerCase().includes(query.toLowerCase()),
        )
      : news;
    setFilteredNews(filtered);
    setVisibleNewsCount(5);
  };

  const handleLoadMore = () => {
    setVisibleNewsCount((prevCount) => prevCount + 5); // Incrementa as notícias visíveis em 5
  };

  return (
    <div className="space-y-8 mt-6">
      <div className="flex flex-col items-center gap-3 py-4">
        <p className="text-sm font-semibold uppercase tracking-widest text-blue-900">
          Encontre o que você precisa
        </p>
        <div className="relative w-full max-w-2xl">
          <MagnifyingGlassIcon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400 pointer-events-none" />
          <input
            type="text"
            value={searchQuery}
            onChange={e => handleSearch(e.target.value)}
            placeholder="Pesquisar notícias..."
            className="w-full border border-gray-300 rounded-xl pl-12 pr-4 py-3 text-base text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Conteúdo Principal */}
        <div className="lg:col-span-3">
          {filteredNews.slice(0, visibleNewsCount).map((item) => (
            <CardNews key={item.ID} news={item} />
          ))}
          {visibleNewsCount < filteredNews.length && (
            <div className="text-center">
              <button
                onClick={handleLoadMore}
                className="mb-10 bg-blue-500 text-white text-lg font-bold px-4 py-2 rounded-md hover:bg-blue-600"
              >
                Mais Notícias
              </button>
            </div>
          )}
        </div>

        {/* Barra Lateral */}
        <div className="lg:col-span-1">
          <Categories
            categories={categories}
            selectedCategory={selectedCategory}
            onCategorySelect={handleCategorySelect}
          />
        </div>
      </div>
    </div>
  );
};

export default News;
